import { useContext } from 'react'

import { useMediaDriverDashboardApi } from '@/common/api/modules/mediaDriver'
import { useSiteId } from '@/common/app/site'
import { dateStr, dateTimeStr } from '@/common/form/date'

import TextButton from '@/components/view/atoms/button/TextButton'
import { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import IconText from '@/components/view/atoms/icon/IconText'
import { TextColor } from '@/components/view/atoms/text/Text'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import MainInnerLoader from '@/components/container/MainInnerLoader'
import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import MediaUsageGuideModalProvider, {
  MediaUsageGuideModalContext
} from '@/components/container/modal/mediaUsageGuide/MediaUsageGuideModalProvider'
import MediaNextActionsPanel from '@/components/container/modules/media/dashboard/MediaNextActionsPanel'
import MediaPreviousComparisonPanel from '@/components/container/modules/media/dashboard/MediaPreviousComparisonPanel'
import MediaSiteSurveyPanel from '@/components/container/modules/media/dashboard/MediaSiteSurveyPanel'
import MediaStatusCards from '@/components/container/modules/media/dashboard/MediaStatusCards'
import MediaWeeklyReport from '@/components/container/modules/media/dashboard/MediaWeeklyReport'

// Media-DRIVER ダッシュボードページ
const MediaDashboardPageContent = () => {
  const siteId = useSiteId()
  const { showModal: showUsageGuide } = useContext(MediaUsageGuideModalContext)

  const { data, error } = useMediaDriverDashboardApi({ site_id: siteId })

  return (
    <Main type={MainLayoutType.MEDIUM}>
      <PageTitle
        title='Media-DRIVER ダッシュボード'
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
        description={
          data
            ? `${data.week_start ? `対象期間: ${dateStr(data.week_start)}（月曜）〜現在 / ` : ''}最終更新: ${dateTimeStr(data.generated_at)}`
            : undefined
        }
        rightNode={
          <TextButton onClick={() => showUsageGuide({ siteId })}>
            <IconText
              iconType={IconType.HELP}
              color={IconColor.LINK}
              textColor={TextColor.LINK}
              iconLine
              noBold
              text={'使い方アドバイス'}
              direction='horizon'
            />
          </TextButton>
        }
      />
      <MainInnerLoader error={error} data={data}>
        {data && (
          <>
            {/* サイト調査の実施状況（3つの分析がすべて実行済みなら非表示） */}
            {!data.current_status.site_survey.all_executed && (
              <MediaSiteSurveyPanel siteId={siteId} siteSurvey={data.current_status.site_survey} />
            )}
            {/* 次に進めるアクション */}
            <MediaNextActionsPanel siteId={siteId} />
            {/* 現在のコンテンツ状況 */}
            <MediaStatusCards
              siteId={siteId}
              market={data.current_status.market}
              competitor={data.current_status.competitor}
              company={data.current_status.company}
            />
            {/* 前回比較 */}
            <MediaPreviousComparisonPanel comparison={data.previous_comparison} />
            {/* 今週の報告 */}
            <MediaWeeklyReport siteId={siteId} weeklyReport={data.weekly_report} />
          </>
        )}
      </MainInnerLoader>
    </Main>
  )
}

const MediaDashboardPage = () => (
  <MediaUsageGuideModalProvider>
    <MediaDashboardPageContent />
  </MediaUsageGuideModalProvider>
)

export default MediaDashboardPage
